/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { oneOffPaymentNoticePostRequestSchema } from './oneOffPaymentNoticePostRequestSchema.ts';
import { oneOffPaymentNoticePostResponseSchema } from './oneOffPaymentNoticePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postOneOffPaymentNotice200Schema = z.lazy(() => oneOffPaymentNoticePostResponseSchema);

/**
 * @description 505 response
 */
export const postOneOffPaymentNotice505Schema = z.any();

export const postOneOffPaymentNoticeMutationRequestSchema = z.lazy(() => oneOffPaymentNoticePostRequestSchema);

export const postOneOffPaymentNoticeMutationResponseSchema = z.lazy(() => postOneOffPaymentNotice200Schema);
